import { Common, ApiBind } from './common.model';

/**
 * ログイン証明情報クラス
 * @remarks
 * APIからのログイン証明情報を格納するクラス
 */
export class LoginCredential extends Common {
  // 次の遷移先
  @ApiBind({ column: 'next_action' })
  nextAction: string;

  // ロール
  @ApiBind({ column: 'allox_role' })
  alloxRole: string;

}
